import styles from './pagination.module.scss';
import MaterialPagination from '@mui/material/Pagination';
import MaterialPaginationItem from '@mui/material/PaginationItem';

/* eslint-disable-next-line */
export interface PaginationProps {
  // boundaryCount?: number,
  // classes?: object,
  color?: 'primary' | 'secondary' | 'standard',
  count: number,
  // defaultPage?: number,
  // disabled?: boolean,
  // getItemAriaLabel?: any,
  // hideNextButton?: boolean,
  // hidePrevButton?: boolean,
  onChange?: (...args: any[]) => void,
  page?: number,
  // renderItem?: any,
  shape?: 'circular' | 'rounded',
  // showFirstButton?: boolean,
  // showLastButton?: boolean,
  // siblingCount?: number,
  size?: 'small' | 'medium' | 'large',
  sx?: any,
  variant?: 'outlined' | 'text',
  className?: string
}

export interface PaginationItemProps {
  // classes?: object,
  color?: 'primary' | 'secondary' | 'standard',
  component?: any,
  // components?: { first?: any, last?: any, next?: any, previous?: any },
  disabled?: boolean,
  // page?: ReactNode,
  selected?: boolean,
  shape?: 'circular' | 'rounded',
  size?: 'small' | 'medium' | 'large',
  // sx?: any,
  type?: 'end-ellipsis' | 'first' | 'last' | 'next' | 'page' | 'previous' | 'start-ellipsis',
  variant?: 'outlined' | 'text'
}

export function Pagination(props: PaginationProps) {
  return (
    <MaterialPagination
      onChange={props.onChange}
      count={props.count}
      page={props.page}
      color={props.color || 'primary'}
      className={props.className}
      shape={props.shape}
      size={props.size}
      variant={props.variant}
    />
  );
}

export function PaginationItem(props: PaginationItemProps) {
  return (
    <MaterialPaginationItem
      color={props.color}
      disabled={props.disabled}
      selected={props.selected}
      size={props.size}
      type={props.type}
      variant={props.variant}
    />
  );
}

export default Pagination;